import React from "react";
import { FaAppStoreIos } from "react-icons/fa";
// import { AiTwotoneAppstore } from "react-icons/ai";
// import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import ServicesCard from "./ServicesCard";

const MyServices = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <ServicesCard
        icons={<BiCodeAlt />}
        title="Web Development"
        subTitle="Crafting robust and scalable websites with clean, efficient code. From static pages to dynamic web apps."
      />
      {/* <ServicesCard
        icons={<SiAntdesign />}
        title="Web Design"
        subTitle="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Hic, provident. Accusamus at dolorem expedita dicta."
      /> */}
      {/* <ServicesCard
        icons={<AiTwotoneAppstore />}
        title="Mobile Application"
        subTitle="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Hic, provident. Accusamus at dolorem expedita dicta."
      /> */}
      <ServicesCard
        icons={<FaAppStoreIos />}
        title="SEO"
        subTitle="Optimizing website to rank higher on search engines, improve visibility, and attract the right audience."
      />
    </div>
  );
};

export default MyServices;
